import { axiosAjax } from '@app/src/config/axios';
import { CategoryModel } from '@app/src/views/Home/listProducts';
import { hydrateData } from './hydrators';
import { isClientEnv } from '@app/src/utils/validations';

export const serviceCategories = {
  async get(): Promise<CategoryModel[]> {
    const appStorage = isClientEnv() && JSON.parse(localStorage.getItem('app'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${appStorage && appStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.get(process.env.API_CATEGORY, config);
      if (data.error) {
        throw new Error();
      }
      return hydrateData(data.data);
    } catch (e) {
      throw new Error(e);
    }
  }
}
